import { createContext, useContext, useEffect, useRef, useState } from "react";
import { http } from "@/lib/api";

const AdsCtx = createContext({});
export const useAds = () => useContext(AdsCtx);

export function inject(el, code) {
  el.innerHTML = "";
  if (!code?.trim()) return;
  try { el.appendChild(document.createRange().createContextualFragment(code)); } catch { /* invalid ad code */ }
}

export function AdsProvider({ children }) {
  const [ads, setAds] = useState({});
  useEffect(() => { http.get("/ads").then((r) => setAds(r.data)).catch(() => {}); }, []);
  useEffect(() => {
    if (!ads.head) return;
    const holder = document.createElement("div");
    inject(holder, ads.head);
    const nodes = [...holder.childNodes];
    nodes.forEach((n) => document.head.appendChild(n));
    return () => nodes.forEach((n) => n.parentNode && n.parentNode.removeChild(n));
  }, [ads.head]);
  return <AdsCtx.Provider value={{ ads, setAds }}>{children}</AdsCtx.Provider>;
}

export function AdSlot({ slot, className = "" }) {
  const { ads } = useAds();
  const ref = useRef(null);
  const code = ads[slot];
  useEffect(() => { if (ref.current) inject(ref.current, code); }, [code]);
  if (!code?.trim()) return null;
  return (
    <div className={`ad-slot ${className}`} data-testid={`ad-slot-${slot}`}>
      <p className="mb-1 text-center font-mono-meta text-[9px] uppercase tracking-widest text-muted-foreground">Publicidade</p>
      <div ref={ref} className="flex justify-center overflow-hidden" />
    </div>
  );
}
